export default {
  ExportGrid: 'export-grid',
  ExportDynamicTemplateImport: 'export-dynamic-template-import',
  ExportXmlFinance: 'export-xml-finance',
  ExportMergeReport: 'export-merge-report', // Xuất khẩu báo cáo mẫu merge
};
